import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BannerNotificationsService } from '../../xform-compat';


/**
 * Service to detect internet connection changes
 */
@Injectable({
  providedIn: 'root'
})
export class ConnectionService {

  /**
   * Observable to detect when the window.online/offline status changes
   */
  private readonly connectionMonitor: Observable<boolean>;
  private aDay = 28800;

  constructor(
    private bannerNotificationService: BannerNotificationsService
  ) {
    this.connectionMonitor = new Observable((observer) => {
      window.addEventListener('offline', () => observer.next(false));
      window.addEventListener('online', () => observer.next(true));
    });

    this.monitor().subscribe(isConnected => {
      if (!isConnected) {
        this.bannerNotificationService
          .warning('You are not connected to the internet - Your changes may not save to the RMS until you\'re online again', undefined, this.aDay);
      } else {
        this.bannerNotificationService.info('Internet connectivity restored', undefined, 6);
      }
    });
  }

  /**
   * Returns the state of the connection
   * @returns {Observable<boolean>}
   */
  public monitor (): Observable<boolean> {
    return this.connectionMonitor;
  }

}
